import { Navigate } from 'react-router'

import { useUserContext } from '@fortem-monorepo/react-spa'

export interface ProtectedRouteProps extends React.PropsWithChildren {
  permissions?: string[]
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permissions = [], children }) => {
  const { hasPermissions } = useUserContext()

  const canAccess = hasPermissions(() => ({ permissions }))

  return canAccess ? children : <Navigate to="/" />
}
